import WidgetPage from './WidgetPage';
import WidgetPageBody from './WidgetPageBody';
import WidgetPageFooter from './WidgetPageFooter';
import WidgetPageHeader from './WidgetPageHeader';

export {
  WidgetPageBody,
  WidgetPageFooter,
  WidgetPageHeader,
};

export default WidgetPage;
